export default __webpack_public_path__ + "static/media/approved-request.dd4c6360.svg";